import React, { useEffect } from 'react';
import { Select, MenuItem } from "@mui/material";
import { SelectChangeEvent } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchCropTypes } from "../../slices/productcostapplication.slice";
import { RootState } from "../../store";
interface CropTypeSelectorProps {
  selectedCropType: string;
  handleCropTypeChange: (event: SelectChangeEvent) => void;
}
const CropTypeSelector: React.FC<CropTypeSelectorProps> = ({
  selectedCropType,
  handleCropTypeChange,
}) => {
  const { cropTypesArray } = useAppSelector(
    (state: RootState) => state.applicationdropdown
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchCropTypes({}));
  }, []);

  return (
    <Select
      value={selectedCropType}
      onChange={handleCropTypeChange}
      size="small"
      sx={{ minWidth: "200px" }}
    >
      <MenuItem value="ALL">All Crops</MenuItem>
      {cropTypesArray.map((crop: any) => (
        <MenuItem key={crop.id} value={crop.id}>
          {crop.cropName}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CropTypeSelector;